import React from 'react';
import cx from 'classnames';
import useBuildVariantProps from '../../../../modules/theme/useBuildVariantProps';
import { WrapTextNodes } from '../../../utils/WrapTextNodes';
import styles from './TableCell.module.scss';
import type { TableCellProps } from './TableCell.types';

const TableCell = (props: TableCellProps) => {
  const {
    className,
    children,
    ...otherProps
  } = props;

  const variantProps = useBuildVariantProps(
    'table-cell',
    {},
    {},
  );

  return (
    <td className={cx(styles.tableCell, className)} { ...otherProps } { ...variantProps }>
      <WrapTextNodes className={styles.text}>{children}</WrapTextNodes>
    </td>
  );
};
export default TableCell;
